import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { decode } from "html-entities";

interface TermsConditionsModalProps {
  open: boolean;
  onClose: () => void;
  termsContent: string;
}

const TermsConditionsModal: React.FC<TermsConditionsModalProps> = ({
  open,
  onClose,
  termsContent,
}) => {
  const { i18n } = useLingui();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: "unset",
          width: "80%",
          m: 0,
        },
      }}
    >
      <Box sx={{ position: "relative", padding: { xs: "20px", md: "44px" } }}>
        <IconButton
          disableRipple
          aria-label="close"
          onClick={onClose}
          data-testid="close-button"
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: "inherit",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          component="div"
          sx={{
            wordWrap: "break-word",
            fontSize: { xs: "22px", md: "33px" },
            fontWeight: "500",
            mb: { xs: "40px" },
            mt: { xs: "20px" },
            p: 0,
          }}
        >
          {t(i18n)`Terms & Conditions`}
        </DialogTitle>
        <DialogContent className="p-0">
          <Typography
            variant="body1"
            component="div"
            dangerouslySetInnerHTML={{ __html: decode(termsContent) }}
            sx={{ fontSize: { xs: "14px" }, lineHeight: { xs: "20px" } }}
          />
        </DialogContent>
      </Box>
    </Dialog>
  );
};
export default TermsConditionsModal;
